import dayjs from 'dayjs'

export const LIKELION_EDU_CAREER = dayjs().diff(dayjs('2013-01-01'), 'year') + 1
